import { ApiError, api } from "@/lib/api";

export type FuturesEmaTimeframe = "5m" | "10m" | "15m" | "30m" | "1h" | "4h" | "1d";

export interface FuturesEmaSignalRow {
  timeframe: FuturesEmaTimeframe;
  ema100: number | null;
  ema200: number | null;
  updatedAt: number | null;
}

export interface FuturesEmaSignalsResponse {
  symbol: string;
  rows: FuturesEmaSignalRow[];
}

export async function getFuturesEmaSignals(
  symbol: string,
): Promise<FuturesEmaSignalsResponse | null> {
  try {
    return await api.get<FuturesEmaSignalsResponse>(
      `/api/market/futures/ema?symbol=${encodeURIComponent(symbol)}`,
    );
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) return null;
    throw err;
  }
}
